var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckFeatureMemberships(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 17.0003C9.74006 17.0003 9.49006 16.9003 9.29006 16.7103L5.29006 12.7103C4.90006 12.3203 4.90006 11.6903 5.29006 11.3003C5.68006 10.9103 6.31005 10.9103 6.70005 11.3003L9.99006 14.5903L17.2801 7.30031C17.6701 6.91031 18.3001 6.91031 18.6901 7.30031C19.0801 7.69031 19.0801 8.32032 18.6901 8.71032L10.6901 16.7103C10.4901 16.9103 10.2401 17.0003 9.98006 17.0003H10.0001Z",
    fill: "#55BB2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckFeatureMemberships);
export default __webpack_public_path__ + "static/media/icon-check-feature-memberships.594bd32be830b6d71b528b3250da5de1.svg";
export { ForwardRef as ReactComponent };